<template>
  <div id="end" class="hidden-sm hidden-md hidden-lg">
    <ul>
      <li>
        <a href="/">
          <img src="/other/home.webp" alt="home" /><br />
          <span>返回首页</span>
        </a>
      </li>
      <li>
        <a href="tel:15837161168"
          ><img src="/other/mobile.webp" alt="mobile" /><br />
          <span>一键拨号</span>
        </a>
      </li>
      <li>
        <a href="sms:037165555168"
          ><img src="/other/ms.webp" alt="tel" /><br />
          <span>一键短信</span>
        </a>
      </li>
      <li>
        <a href="/message"
          ><img src="/other/contact.webp" alt="contact" /><br />
          <span>联系我们</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#end img{
  display: inline-block;
}
</style>
